import { LearningObjectiveType, Year } from '@types';
import { useMemo } from 'react';

const useCurriculumYears = (years: Year[]) => {
    const sortedYears = useMemo(() => {
        return years
            .sort((a, b) => a.id - b.id)
            .map((year) => ({ ...year, id: year.id.toString() }));
    }, [years]);

    const yearsMap: Record<
        LearningObjectiveType,
        { id: string; name: string }[]
    > = {
        [LearningObjectiveType.SATS]: sortedYears.filter((year) => {
            return year.name === 'Year 6';
        }),
        [LearningObjectiveType.GCSE]: sortedYears.filter((year) => {
            return ['Year 10', 'Year 11'].includes(year.name);
        }),
        [LearningObjectiveType.STANDARD]: sortedYears,
    };

    return { yearsMap };
};

export default useCurriculumYears;
